var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Cursor extends Component {
    constructor() {
        super('Cursor', false);
        this.mouseX = 0;
        this.mouseY = 0;
        this.pageX = 0;
        this.pageY = 0;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if (('ontouchstart' in window === false || navigator.maxTouchPoints === 0)) {
                $(window).on('scroll', (event) => {
                    this.setAppearance();
                });
                $('body').on('mousemove', (event) => {
                    this.mouseX = event.clientX;
                    this.mouseY = event.clientY;
                    this.pageX = event.pageX;
                    this.pageY = event.pageY;
                    this.setAppearance();
                });
            }
            this.success();
        });
    }
    setAppearance() {
        $('#cursor').removeClass('d-none').css({
            left: this.mouseX,
            top: this.mouseY
        });
        $('#cursor').removeClass('d-none');
        $('body').addClass('custom-cursor-enabled');
        // Get the element under the cursor
        const target = document.elementFromPoint(this.mouseX, this.mouseY);
        if (target.tagName == 'A' || $('body').hasClass('home')) {
            $('#cursor .prev, #cursor .next').addClass('d-none');
            $('#cursor .pointer').removeClass('d-none');
        }
        else if (this.pageX <= $(window).width() / 2 && $(target).parents('.carousel').find('.carousel-item').length > 1) {
            $('#cursor .pointer, #cursor .next').addClass('d-none');
            $('#cursor .prev').removeClass('d-none');
        }
        else if (this.pageX > $(window).width() / 2 && $(target).parents('.carousel').find('.carousel-item').length > 1) {
            $('#cursor .prev, #cursor .pointer').addClass('d-none');
            $('#cursor .next').removeClass('d-none');
        }
        else {
            $('#cursor').addClass('d-none');
            $('body').removeClass('custom-cursor-enabled');
        }
    }
}
